import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";
export default function NewsSection() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const [dataNews, setDataNews] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/news");
                setDataNews(respons.data.data)
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error)
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };


    const showData = dataNews.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 w-[32%] flex flex-col shadow-[0px_0px_10px_#00000029] rounded-[8px]">
            <div className="w-[100%] h-[250px] border-b-[3px] border-b-[#017E89]">
                <img className="w-full h-full rounded-t-[8px] object-cover" src={el.image} alt="" />
            </div>
            <div className="w-[100%] p-[20px] flex flex-col justify-between gap-[15px]">
                <div className="flex flex-col gap-[15px]">
                    <div className="capitalize font-bold text-[20px]">
                        {t(getLocalizedText({ A: el.title_ar, E: el.title_en }))}
                    </div>
                    <p>
                        {t(getLocalizedText({ A: el.content_ar, E: el.content_en }).length > 50
                            ? getLocalizedText({ A: el.content_ar, E: el.content_en }).substring(0, 100) + "..."
                            : getLocalizedText({ A: el.content_ar, E: el.content_en }))}
                    </p>
                    <div className="flex items-center gap-[5px]">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                        <div className="font-bold text-[#017E89]">
                            {new Date(el.news_date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                        </div>
                    </div>
                </div>
                <Link to={`/newsDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("Read More")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )

    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("News & Events")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="f-col flex gap-[15px]">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/news"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}